<template>
    <div v-if="form">
        <template v-if="form.opcoesEntrada.length > 0">
            <rkm-row cols="2">
                <rkm-col
                    v-for="opcaoEntrada in form.opcoesEntrada"
                    class="mb-3"
                    v-bind:key="opcaoEntrada.id"
                >
                    <template v-if="opcaoEntrada.prioridadeObrigatoria">
                        <rkm-button
                            @click="$refs.ModalPrioridade.open(centroCusto, opcaoEntrada)"
                            block
                            class="big-button"
                            color="primary"
                        >
                            {{ opcaoEntrada.nome }}
                        </rkm-button>
                    </template>

                    <template v-else>
                        <rkm-button
                            @click="save(opcaoEntrada)"
                            block
                            class="big-button"
                            color="primary"
                        >
                            {{ opcaoEntrada.nome }}
                        </rkm-button>
                    </template>
                </rkm-col>
            </rkm-row>

            <ModalPrioridade
                :prioridades="form.prioridades"
                ref="ModalPrioridade"
            />
        </template>

        <template v-else>
            <rkm-row>
                <rkm-col>
                    <rkm-alert>
                        Registre uma opção de entrada para continuar
                    </rkm-alert>
                </rkm-col>
            </rkm-row>
        </template>
    </div>
</template>

<script>
// Componentes.
import ModalPrioridade from './components/prioridade/Modal'

// Mixins.
import { error, repository } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    components: { ModalPrioridade },
    computed: {
        ...mapGetters({
            centroCusto: 'getCentroCusto',
            cliente: 'getCliente',
            lotacao: 'getLotacao',
        }),
    },
    created() {
        this.repositories = {
            fila: this.getConectaSusRepository('painelSenha.fila')
        }
    },
    data: () => ({
        form: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.fila.create()
                .then(response => {
                    this.form = Object.assign(response.data.form)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save(opcaoEntrada) {
            const request = {
                centro_custo_id: this.centroCusto.id,
                opcao_entrada_id: opcaoEntrada.id,
                prioridade_id: null,
            }

            this.setLoading()

            this.repositories.fila.store(request)
                .then(response => {
                    const params = {
                        infraestrutura: this.lotacao.infraestrutura.nome,
                        setor: this.centroCusto.setor.nome,
                        senha: response.data.senha,
                        data: response.data.dataEmissao,
                        hora: response.data.horaEmissao,
                        cliente: this.cliente.nome,
                    }

                    this.download(params)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        download(params) {
            const content = `infraestrutura=${params.infraestrutura}\nsetor=${params.setor}\nsenha=${params.senha}\ndata=${params.data}\nhora=${params.hora}\ncliente=${params.cliente}`
            const blob = new Blob([content], { type: "text/plain" })
            const url = URL.createObjectURL(blob)
            const link = document.createElement("a")

            link.href = url
            link.download = "senha.txt"

            link.click()

            URL.revokeObjectURL(url)
        },
    },
    mixins: [ error, repository ],
    mounted() {
        this.load()
    },
}
</script>

<style scoped>
.big-button {
    font-size: 30px;
    font-weight: bold;
    height: 140px;
}
</style>